import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../shared/ui/Layout";
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import WhatWeDoPage from "../pages/WhatWeDoPage";
import HowItWorksPage from "../pages/HowItWorksPage";
import BlogPage from "../pages/BlogPage";
import ContactPage from "../pages/ContactPage";
import "../shared/styles/globals.scss";
import "../shared/styles/animations.scss";
import "../shared/styles/page-header.scss";
import BlogPostPage from "../pages/BlogPostPage/BlogPostPage";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy.jsx";
import Terms from "../pages/Terms/Terms.jsx";
import AccessibilityStatement from "../pages/AccessibilityStatement";
import ScrollToTop from "./providers/router/ScrollToTop.jsx";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/what-we-do" element={<WhatWeDoPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route
            path="/accessibility-statement"
            element={<AccessibilityStatement />}
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
